function findDataStoreItemValue(dataStoreItems, behaviour, key, params = {}){
  if (!key) return ''

  const { editorType, editorId, groupKey } = params || {}

  const dataStoreItem = dataStoreItems.find((item) => {
    const {
      key: itemKey, group_key, editor_type, editor_id,
    } = item

    const keysMatch = itemKey === key

    if (behaviour === 'group'){
      return keysMatch && groupKey && group_key === groupKey
    }

    if (behaviour === 'replace'){
      return keysMatch
    }

    return (
      keysMatch
      && ((groupKey && group_key === groupKey) || (editor_type === editorType && editor_id === editorId))
    )
  })

  return dataStoreItem && dataStoreItem.value ? dataStoreItem.value : ''
}

export default findDataStoreItemValue
